<div
  #globalBanner
  [hidden]="!isVisible"
  class="global-banner {{ type }}-banner"
  [ngClass]="{ 'has-action': !!actionIcon }"
  i2gSticky
  [sticky]="stickyConfig"
  [attr.data-e2e-id]="e2eId"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (click)="onBannerAction($event, false)"
>
  <ng-container [ngSwitch]="containsHtml">
    <p
      *ngSwitchCase="true"
      class="message"
      #globalBannerMessage
      [innerHTML]="message | safe: 'html'"
    ></p>

    <p *ngSwitchDefault #globalBannerMessage class="message">
      {{ message }}
    </p>
  </ng-container>

  <button
    *ngIf="actionIcon"
    type="button"
    class="banner-action"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    (click)="onBannerAction($event, true)"
  >
    <i2g-icon [icon]="actionIcon"></i2g-icon>
  </button>
</div>
